import React, { useEffect } from "react";

export const Footer = () => {
  useEffect(() => {
    // Fix footer alignment issues comprehensively
    const footerAddress = document.querySelector('#footer .footer-address');
    if (footerAddress) {
      // Style the paragraphs to have consistent alignment
      const paragraphs = footerAddress.querySelectorAll('p');
      paragraphs.forEach(p => {
        p.style.display = 'flex';
        p.style.alignItems = 'flex-start';
        p.style.marginBottom = '8px';
      });
      
      // Style the icons consistently
      const icons = footerAddress.querySelectorAll('i.fa');
      icons.forEach(icon => {
        icon.style.marginRight = '10px';
        icon.style.display = 'inline-block';
        icon.style.flexShrink = '0';
        icon.style.width = '22px';
        icon.style.textAlign = 'left';
      });
      
      // Style the text spans
      const textSpans = footerAddress.querySelectorAll('.address-text');
      textSpans.forEach((span, index) => {
        span.style.flex = '1';
        // First span is the address (multi-line), give it more spacing
        if (index === 0) {
          span.style.lineHeight = '1.68'; // 20% more than 1.4
        } else {
          span.style.lineHeight = '1.4';
        }
      });
    }
  }, []);

  return (
    <div id="footer">
      <div className="container">
        <div className="row footer-content">
          
          <div className="col-md-4 col-sm-12">
            <div className="footer-section">
              <h4>Physical Address</h4>
              <div className="footer-address">
                <p>
                  <a href="https://www.google.com/maps/search/?api=1&query=13+Laidlaw+Way,+East+Tāmaki,+Auckland+2019,+New+Zealand" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-map-marker" style={{fontSize: '22px'}}></i>
                  </a>
                  <span className="address-text">
                    Unit 7, 13 Laidlaw Way,<br />
                    East Tāmaki,<br />
                    Auckland 2019,<br />
                    New Zealand
                  </span>
                </p>
                <p>
                  <a href="tel:+6498864638">
                    <i className="fa fa-phone" style={{fontSize: '22px'}}></i>
                  </a>
                  <span className="address-text">
                    <a href="tel:+6498864638">+64 9 886 4638</a>
                  </span>
                </p>
              </div>
            </div>
          </div>
          
          <div className="col-md-4 col-sm-12">
            {/* Spacer column to push Quick Links to the right */}
          </div>
          
          <div className="col-md-4 col-sm-12">
            <div className="footer-section">
              
            </div>
          </div>
        </div>
        
        <div className="footer-bottom text-center">
          <div className="footer-legal-links" style={{marginBottom: '15px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: '5px'}}>
            <a href="/legal/terms-of-use.html" target="_blank" rel="noopener noreferrer" style={{color: '#2B4B8C', textDecoration: 'none', margin: '0 10px'}}>
              Terms of Use
            </a>
            <span style={{color: '#666'}}>|</span>
            <a href="/legal/privacy-policy.html" target="_blank" rel="noopener noreferrer" style={{color: '#2B4B8C', textDecoration: 'none', margin: '0 10px'}}>
              Privacy Policy
            </a>
            <span style={{color: '#666'}}>|</span>
            <a href="/legal/fair-use-policy.html" target="_blank" rel="noopener noreferrer" style={{color: '#2B4B8C', textDecoration: 'none', margin: '0 10px'}}>
              Fair Use Policy
            </a>
            <span style={{color: '#666'}}>|</span>
            <a href="/legal/disclaimer.html" target="_blank" rel="noopener noreferrer" style={{color: '#2B4B8C', textDecoration: 'none', margin: '0 10px'}}>
              Disclaimer
            </a>
            <span style={{color: '#666'}}>|</span>
            <a href="/legal/attributions.html" target="_blank" rel="noopener noreferrer" style={{color: '#2B4B8C', textDecoration: 'none', margin: '0 10px'}}>
              Attributions
            </a>
            <span style={{color: '#666'}}>|</span>
            <a href="/sms-opt-in" target="_blank" rel="noopener noreferrer" style={{color: '#2B4B8C', textDecoration: 'none', margin: '0 10px'}}>
              SMS Opt-In
            </a>
            <span style={{color: '#666'}}>|</span>
            <button
              onClick={() => window.dispatchEvent(new Event('openCookieSettings'))}
              style={{
                background: 'none',
                border: 'none',
                color: '#2B4B8C',
                textDecoration: 'none',
                margin: '0 10px',
                cursor: 'pointer',
                padding: '0',
                font: 'inherit'
              }}
              onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
              onMouseOut={(e) => e.target.style.textDecoration = 'none'}
            >
              Cookie Settings
            </button>
          </div>
          <p style={{color: '#2c2c2c'}}>
            &copy; {new Date().getFullYear()} Yuccan International Ltd.
          </p>
        </div>
      </div>
    </div>
  );
};